module.exports = __webpack_public_path__ + "img/icon-package-calling-credit-light.90ea80b.svg";